export default "__VITE_ASSET__BiqW47Ei__"